<tt-page>
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2datataskedit'" class="col-xs-12 col-md-6 p-5">
            <tt-page-heading ttModel="h_stored_procedures" ttTranslate></tt-page-heading>
        </tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5">
                <form (ngSubmit)="searchItems()">
                    <tt-input
                        *ngIf="!!setting"
                        ttLabel="searchtext"
                        [(ttModel)]="setting.searchtext"
                        (ttModelChange)="onSearchTextChanged($event)"
                        [ttButtons]="searchTextButtons">
                    </tt-input>
                </form>
            </tt-card>
            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="new_p2_datatask" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createDataTask($event)"></tt-button>
            </tt-card>
        </div>

        <ng-container *ngIf="itemState !== 'p2datataskedit'; else inlineEditor">
            <tt-list [ttData]="procedures" (ttClick)="openDataTask($event.item, $event.event)"></tt-list>
        </ng-container>
        <ng-template #inlineEditor>
            <div class="col-xs-12 col-md-6 p-5">
                <tt-list [ttData]="procedures" (ttClick)="openDataTask($event.item, $event.event)"></tt-list>
            </div>
            <div *ngIf="selectedDataTaskKeyno !== ''" class="col-xs-12 col-md-6 p-5">
                <tt-p2-data-task-edit
                    [p2DataTaskKeyno]="selectedDataTaskKeyno"
                    [inline]="true"
                    (onSave)="loadProcedures()">
                </tt-p2-data-task-edit>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-button-goto
                ttText="new_p2_datatask"
                ttGoto="p2datataskedit-test"
                [ttGotoParms]="{ p2_datatask_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
            <form (ngSubmit)="searchItems()">
                <tt-input
                    *ngIf="!!setting"
                    ttLabel="searchtext"
                    [(ttModel)]="setting.searchtext"
                    (ttModelChange)="onSearchTextChanged($event)"
                    [ttButtons]="searchTextButtons">
                </tt-input>
            </form>
        </tt-card>
        <tt-list [ttData]="procedures" (ttClick)="openDataTask($event.item, $event.event)"></tt-list>
    </ng-template>
</tt-page>
